import { render, staticRenderFns } from "./appeaIndicators.vue?vue&type=template&id=3bd68b33&"
import script from "./appeaIndicators.vue?vue&type=script&lang=js&"
export * from "./appeaIndicators.vue?vue&type=script&lang=js&"
import style0 from "./appeaIndicators.vue?vue&type=style&index=0&id=3bd68b33&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports